import { httpRequest } from "../../http";
import type { Ad } from "@models/Ad.model";

export interface StoreCollectionSummary {
  id: number;
  name: string;
  copy_text?: string;
  tag_count: number;
  ad_count: number;
  ads: Ad[]; // capped preview — use ad_count for totals
}

export interface StoreTagSummary {
  id: number;
  name: string;
  copy_text?: string;
  tag_count: number;
  ad_count: number;
  ads: Ad[]; // capped preview — use ad_count for totals
}

export interface StoreTagGroupSummary {
  id: number;
  name: string;
  tags: StoreTagSummary[];
}

export interface StorePageResponse {
  page: string;
  hero?: string;
  copy_text?: string;
  collections: StoreCollectionSummary[];
  tag_groups: StoreTagGroupSummary[];
}

export class CommandGetStorePage {
  async run(organizationId: string, name: string): Promise<StorePageResponse | undefined> {
    const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/${organizationId}/store/pages/`;
    const url = `${base}?${new URLSearchParams({ name })}`;
    try {
      return await httpRequest<StorePageResponse>(url);
    } catch (error) {
      console.error("Error fetching store page:", error);
      throw error;
    }
  }
}
